var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook 1",
    clipPath: "url(#clip0_137_50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.78994 3.11128H8.01452C6.62802 3.11128 6.32367 3.78762 6.32367 4.80212V6.81423H9.70536L9.24885 10.1959H6.37439V18.7854H2.90818V10.1959H0.0168457V6.81423H2.90818V4.34561C2.85229 3.75945 2.92515 3.16812 3.1217 2.61307C3.31825 2.05803 3.63371 1.55266 4.04602 1.13229C4.45833 0.711928 4.95755 0.386736 5.50869 0.179489C6.05983 -0.0277585 6.64961 -0.112064 7.23674 -0.0675229C8.09541 -0.0754486 8.95372 -0.0302442 9.80681 0.0677737L9.78994 3.11128Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.79,
    height: 18.8529,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook 1.d8d0a29bbe5c0f6a42f64e6609e81a90.svg";
export { ForwardRef as ReactComponent };